import React, {Component} from 'react';
import {Bar} from 'react-chartjs-2';
import {injectIntl} from 'react-intl';
import {getAccumulation, getChartDataByDay, getDifference} from './budget_charts_util';

class ActualVarianceToPlanChart extends Component {
	getChartData() {
		const {itemsOutsideProjectPeriod} = this.props;
		const {formatMessage} = this.props.intl;
		const {isMoneyTabSelected, actualPerDay, forecastPerDay, registeredMinutesPerDay, plannedMinutesPerDay, project, labels} = this.props.data;

		const actualVarianceToPlan = isMoneyTabSelected
			? getDifference(getChartDataByDay({project, dayData: actualPerDay}), getChartDataByDay({project, dayData: forecastPerDay}))
			: getDifference(
					getChartDataByDay({project, dayData: registeredMinutesPerDay}).map(item => item / 60),
					getChartDataByDay({project, dayData: plannedMinutesPerDay}).map(item => item / 60)
			  );

		return {
			datasets: [
				{
					label: formatMessage({id: 'project_budget.accumulated_variance'}),
					type: 'line',
					borderColor: '#6e0fea',
					pointBackgroundColor: '#6e0fea',
					pointHoverBorderColor: '#fff',
					pointHoverRadius: 0,
					pointHoverBorderWidth: 2,
					pointRadius: 0,
					fill: false,
					backgroundColor: '#fff',
					lineTension: 0,
					borderWidth: 2,
					data: getAccumulation(actualVarianceToPlan),
				},
				{
					label: `${formatMessage({id: 'project_budget.actual_vs_plan'})} (${project.billable ? formatMessage({id: 'project_budget.revenue'}) : formatMessage({id: 'common.cost'})})`,
					borderColor: '#bfa2fc',
					pointHoverRadius: 0,
					pointHoverBorderWidth: 2,
					pointBackgroundColor: '#cecbf7',
					pointHoverBorderColor: '#fff',
					pointRadius: 0,
					fill: true,
					backgroundColor: 'rgba(191, 162, 252, 0.2)',
					borderWidth: 1,
					data: actualVarianceToPlan,
				},
			].concat(itemsOutsideProjectPeriod ? itemsOutsideProjectPeriod : []),
			labels,
		};
	}

	render() {
		return <Bar data={this.getChartData()} options={this.props.options} plugins={this.props.plugins} redraw />;
	}
}

export default injectIntl(ActualVarianceToPlanChart);
